import { DateTime } from "luxon";

export const dateDMY = (date) => {
  const formatDate = DateTime.fromISO(date)
    .setZone("America/Argentina/Buenos_Aires")
    .toFormat("dd-MM-yyyy");
  return formatDate;
};

export const dateHHMM = (date) => {
  const formatDate = DateTime.fromISO(date)
    .setZone("America/Argentina/Buenos_Aires")
    .toFormat("hh:mm");
  return formatDate;
};
